// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"As-z","giftOrPromoSelector":"Bs-z","disabled":"Cs-z","subTitle":"Ds-z","selectShipAddressMessage":"Es-z","changePayment":"Fs-z"};